import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const PageBanner = ({ title, crumbs = [] }) => (
  <section className="relative overflow-hidden navy-panel">
    <div
      className="pointer-events-none absolute inset-0 opacity-[0.06]"
      style={{
        backgroundImage:
          'linear-gradient(rgba(255,255,255,.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.5) 1px, transparent 1px)',
        backgroundSize: '56px 56px',
      }}
    />
    <div className="relative max-w-[1240px] mx-auto px-4 lg:px-6 py-14 md:py-16">
      <div className="flex items-center gap-1 text-white/60 text-[13px] mb-3 animate-[fadeInUp_.6s_ease-out]">
        <Link to="/" className="hover:text-[#e8c887] transition-colors">Home</Link>
        {crumbs.map((c, i) => (
          <span key={i} className="flex items-center gap-1">
            <ChevronRight className="w-4 h-4" />
            <span className={i === crumbs.length - 1 ? 'text-[#e8c887]' : ''}>{c}</span>
          </span>
        ))}
      </div>
      <h1 className="font-heading text-[34px] md:text-[46px] font-bold tracking-tight text-white animate-[fadeInUp_.7s_ease-out]">
        {title}
      </h1>
      <span className="block h-[2px] w-16 mt-5 rounded-full" style={{ background: 'linear-gradient(90deg,#e8c887,#c9a24b)' }} />
    </div>
  </section>
);

export default PageBanner;
